import { render, staticRenderFns } from "./SelectedChips.vue?vue&type=template&id=2c65a2a6&"
import script from "./SelectedChips.vue?vue&type=script&setup=true&lang=ts&"
export * from "./SelectedChips.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c65a2a6')) {
      api.createRecord('2c65a2a6', component.options)
    } else {
      api.reload('2c65a2a6', component.options)
    }
    module.hot.accept("./SelectedChips.vue?vue&type=template&id=2c65a2a6&", function () {
      api.rerender('2c65a2a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/TheFilters/doctors/components/DoctorFilters/components/SelectedChips/SelectedChips.vue"
export default component.exports